import gql from 'graphql-tag'

export default gql`
  query WestfieldDirectStore($centreSlug: String!) {
    cfStoreCollection(
      where: {
        AND: [
          { centre: { slug: $centreSlug } }
          { retailer: { slug: "westfield-online" } }
        ]
      }
      limit: 1
    ) {
      items {
        title
        physicalAddress
        landmarkDescription
        mapIdentifier
        storeFrontImage {
          url
        }
      }
    }
  }
`
